import BookFiltersStore from "../../../Flux/Stores/BookFiltersStore";

const DEBUG_MODE = window.LOCAL_DEBUG_MODE || false;

export const handleNavigateToWorkbook = (e, rowData, navigate) => {
	const contextValues = BookFiltersStore.getContextValues();
	const { MasterPlatformID, CampaignUniqueCode, ParentUniqueIDcode, HierarchyLevelID } = rowData || {};
	const url = new URL(`${window.location.origin}/Workbook/`);

	const queryParams = {
		context_id: contextValues.contextId,
		agency: contextValues?.agency?.name,
		client: contextValues?.client?.name,
		region: contextValues?.region?.name,
		country: contextValues?.country?.name,
		hierarchyLevelID: HierarchyLevelID,
		platformID: MasterPlatformID,
		// activationCampaignID: CampaignUniqueCode,
		// primaryCampaignID: ParentUniqueIDcode,
		campaignID: CampaignUniqueCode,
		masterCampaignID: ParentUniqueIDcode
	};

	Object.entries(queryParams).forEach(([key, val]) => url.searchParams.append(key, val));

	if (DEBUG_MODE === true) {
		navigate(`${url.pathname}${url.search}`);
	} else {
		window.open(url.toString());
	}

	// if ctrl key is held, open in new tab
	// disabled for now because our users are not used to this behavior
	// if (e?.ctrlKey) {
	// 	window.open(url.toString());
	// } else {
	// 	navigate(`${url.pathname}${url.search}`);
	// }
};
